import { HeroSection } from "./components/heroSection";
import { Payment } from "./components/payment";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import styles from "./ProtestPaymentPage.module.css";

const stripePromise = loadStripe(
  import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY ||
    "pk_test_51LB5eCDJVPEOLc88uxXxMGVWs7SJ5LpzQj9UghEY1SbYgibsNwxpShB7J2erPnLvnHqKM0eH9UY8LWlKgM9UoUB900Ddq3xT7J"
);

/**
 * ProtestPaymentPage Component
 * Page for displaying protest payment information and fees
 */
export const ProtestPaymentPage = () => {
  return (
    <div className={styles.page}>
      <div className={styles.heroWrap}>
        <Elements stripe={stripePromise}>
          <HeroSection />
        </Elements>
      </div>
      <div className={styles.paymentWrap}>
        <Payment />
      </div>
    </div>
  );
};
